import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AuthService from '../services/authService';

/**
 * Protected Route Component
 * Checks if user has valid session before allowing access to protected routes
 */
const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null); // null = checking, true = authenticated, false = not authenticated
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const checkSession = async () => {
      try {
        const authenticated = await AuthService.isAuthenticated();
        setIsAuthenticated(authenticated);
        
        if (authenticated) {
          // Verify we can get user info
          try {
            const userId = await AuthService.getCurrentUserId();
            localStorage.setItem('userId', userId);
            // console.log('✅ Valid session found for user:', userId);
          } catch (error) {
            // console.warn('⚠️ Could not get user ID:', error);
            setIsAuthenticated(false);
          }
        }
      } catch (error) {
        console.error('Session check failed:', error);
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    checkSession();
  }, []);

  // Show loading state while checking session
  if (loading || isAuthenticated === null) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column',
        gap: '1rem'
      }}>
        <div>Checking authentication...</div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return (
      <Navigate 
        to="/login" 
        state={{ 
          message: 'Please log in to access this page',
          redirectTo: location.pathname 
        }} 
        replace 
      />
    );
  }

  // User is authenticated, render the protected content
  return children;
};

export default ProtectedRoute;



